import { render, staticRenderFns } from "./TechApps.vue?vue&type=template&id=62120e3a&scoped=true&"
import script from "./TechApps.vue?vue&type=script&lang=js&"
export * from "./TechApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62120e3a",
  null
  
)

export default component.exports